(function($) {

	'use strict';

    let global_headerHeight;

    const pbmain = {

        init: () => {
            pbmain.clonePBFormSubmitButtons();
            pbmain.bindFormValidation();
			pbmain.initMobileNav();
            pbmain.initSubMenu();
            pbmain.initFixedNav();
            pbmain.initPopupFormTriggers();
            pbmain.initFormCustomSubmitButton();

            if ( $('div.accordion').length ) {
                pbmain.initAccordions();
            }
        },

        initFormCustomSubmitButton : () => {

            document.querySelectorAll('.pb-trigger-formsubmit').forEach(function(trigger) {
                trigger.addEventListener('click', function() {
                    var closestForm = trigger.closest('form');
                    
                    if (closestForm) {
                        var submitButton = closestForm.querySelector('input[type="submit"].gform_button');
                        
                        if (submitButton) {
                            submitButton.click();
                        }
                    }
                });
            });                      

        },

        initAccordions : () => {
            
            $('div.accordion a.open-item').click(function(e) {

                e.preventDefault();

                $(this).parent().find('div.content').slideToggle();
                
                $(this).toggleClass('active');
            });

        },

		initMobileNav : () => {

			$('header').find('.mobile-menu-btn').on('click', function(e) {
				e.preventDefault();
				
				let $body = $('body');
				
                $body.toggleClass('nav-is-open');
                $(this).toggleClass('is-active');
            });

            $('div.nav-active-bg').click(function(e) {

                if ( $('body').hasClass('nav-is-open')) {
                    $('header').find('.mobile-menu-btn').trigger('click');
                }
            });
		},
		
		initSubMenu : () => {

            $('.dropdown-toggle').on('click', function(e) {

                if (e.target.closest('.caret-click')) {
                    return false;
                }

                else {
                    if ( !$(this).attr('href') ) {
                        $(this).find('.caret-click').trigger('click');
                    }
                }
            });

            $('.caret-click').on('click', function(e) {

                if (e.target.closest('.caret-click')) {

                    let $caret       = $(this)
                    ,   $menu        = $('nav.main-nav')
                    ,   $navlistwrap = $('nav.main-nav').find('div.nav-list-wrap')
                    ,   $submenu     = $caret.closest('li.menu-item').find('.sub-menu');

                    if ( $submenu.hasClass('is-active') ) {
                        $caret.removeClass('is-active');
                        $submenu.removeClass('is-active');
                        $menu.removeClass('is-subnav-active');
                        $navlistwrap.removeClass('is-subnav-active');
                    }
                    
                    else {
                        $caret.addClass('is-active');
                        $submenu.addClass('is-active');
                        $menu.addClass('is-subnav-active');
                        $navlistwrap.addClass('is-subnav-active');
                    }

                }

            });
        },

        initFixedNav : () => {
            var header = document.querySelector('.pb-main-header');
            var headerPlaceholder = document.querySelector('.header-placeholder');
            var headerHeight = header.offsetHeight;
            var originalOffsetTop = header.offsetTop;
            var buffer = 50; // Adjust this value as needed
            var lastScrollTop = 0;
            
            window.addEventListener('scroll', function() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if (scrollTop > lastScrollTop) { // Scrolling down
                if (scrollTop >= originalOffsetTop + headerHeight) {
                    header.classList.remove('fixed');
                    headerPlaceholder.style.display = 'none';
                }
                } else { // Scrolling up
                if (scrollTop <= originalOffsetTop + buffer) {
                    header.classList.remove('fixed');
                    headerPlaceholder.style.display = 'none';
                } else {
                    header.classList.add('fixed');
                   // headerPlaceholder.style.display = 'block';
                    //headerPlaceholder.style.height = headerHeight + 'px';
                }
                }
                
                lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
            });
        },

        clonePBFormSubmitButtons : () => {

            $('form.pb-form').each(function(i, form) { 

                let $self = $(form);

                if ($self.hasClass('pb-form')) {

                    let $submitbtn = $self.find('input[type="submit"].gform_button')
                    , 	$submitbtn_text = $submitbtn.attr('value');

                    $submitbtn.addClass('sr-only');

                    $submitbtn.after('<input type="submit" class="pb-validation-btn" value="' + $submitbtn_text + '" />');

                }

            });

        },
        
        bindFormValidation: () => {
            
            $('.pb-validation-btn').on('click', function(e) {
                e.preventDefault();

                let thissubbtn=$(e.target),self = $(this),
                    the_form = self.closest('form.pb-form'),
                    form_required = the_form.find('.form-required'),
                    isValidated = true, 
                    oldbtntext=thissubbtn.attr('value'),
                    errorMessage = 'This is a required field',
                    emailFormatErrorMessage = 'Invalid E-mail address format.';

                thissubbtn.attr('disabled','disabled');
                thissubbtn.attr('value','Sending...');

                the_form.find('.gfield_description.validation_message').remove();

                if ( the_form.hasClass('asterisk-error') ) {
                    errorMessage = '*';
                    emailFormatErrorMessage = '*';
                }

                form_required.each(function(i, el) {


                    if ($(el).is(':visible')) {


                        let current_field = $(el).find('div.ginput_container').children('input, textarea');


                        if ($(el).hasClass('is-checkbox')) {
                            let atLeastOneIsChecked = $(el).find('div.ginput_container_checkbox :checkbox:checked').length > 0;

                            if (!atLeastOneIsChecked) {
                                isValidated = false;
                                $(el).append('<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                            }

                        } else if ($(el).hasClass('is-radio')) {

                            let atLeastOneIsRadio = $(el).find('div.ginput_container_radio :radio:checked').length > 0;

                            if (!atLeastOneIsRadio) {
                                isValidated = false;
                                $(el).append('<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                            }
                        } else if ($(el).hasClass('is-list')) {

                            let atLeastOneHasTextEmpty = $(el).find('table.gfield_list input:text').filter(function() {
                                return !this.value;
                            }).length > 0;

                            if (atLeastOneHasTextEmpty) {
                                isValidated = false;
                                $(el).append('<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                            }
                        } else if ($(el).hasClass('is-address')) {

                            let atLeastOneHasTextEmpty = false;

                            $(el).find('div.ginput_container input').each(function(i, field) {
                                let jq_this = $(field);//console.log('a:' + jq_this.parent().hasClass('ginput_full address_line_2'));

                                if (!jq_this.val() && !jq_this.parent().hasClass('ginput_full address_line_2')) {
                                    atLeastOneHasTextEmpty = true;
                                    jq_this.parent().append('<span class="gfield_description validation_message" style="display:block;">' + errorMessage + '</span>');
                                }

                            });

                            if (atLeastOneHasTextEmpty) {
                                isValidated = false;
                            }
                        } else if ($(el).hasClass('is-select')) {

                            let atLeastOneHasTextEmpty = false;

                            $(el).find('div.ginput_container select').each(function(i, field) {
                                let jq_this = $(field);

                                if (!jq_this.val()) {
                                    atLeastOneHasTextEmpty = true;
                                    jq_this.parent().append('<span class="gfield_description validation_message" style="display:block;">' + errorMessage + '</span>');
                                }

                            });

                            if (atLeastOneHasTextEmpty) {
                                isValidated = false;
                            }
                        } else if (current_field.val() === '' && !$(el).hasClass('is-address') ) {
                            isValidated = false;
                            $(el).append('<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                        } else if ($(el).hasClass('email-format')) {

                            let pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

                            if (!pattern.test(current_field.val())) {
                                isValidated = false;
                                $(el).append('<div class="gfield_description validation_message" style="display:block;">' + emailFormatErrorMessage + '</div>');
                            }

                        }


                    }



                }); // .each

                if (isValidated) {
                    the_form.find('input[type="submit"].gform_button.button').trigger('click');
                    return true;
                } 

                else {
				    thissubbtn.removeAttr('disabled');
				    thissubbtn.attr('value', oldbtntext);
                    return false;
                }

            }); // .onclick
        },

        bindFormValidationVanillaJS : () => {
            
            document.querySelectorAll('.pb-validation-btn').forEach(function(btn) { 
                btn.addEventListener('click', function(e) {console.log('testaj121');
                    e.preventDefault();

                    let thissubbtn = e.target, self = this,
                        the_form = self.closest('form.pb-form'),
                        form_required = the_form.querySelectorAll('li.form-required'),
                        isValidated = true, 
                        oldbtntext = thissubbtn.getAttribute('value'),
                        errorMessage = 'Please complete all of the form fields.',
                        emailFormatErrorMessage = 'Invalid E-mail address format.';

                    thissubbtn.setAttribute('disabled','disabled');
                    thissubbtn.setAttribute('value','Sending...');
                
                    the_form.querySelectorAll('.gfield_description.validation_message').forEach(function(msg) {
                        msg.remove();
                    });

                    if (the_form.classList.contains('asterisk-error')) {
                        errorMessage = '*';
                        emailFormatErrorMessage = '*';
                    }

                    form_required.forEach(function(el) {

                        if (el.style.display !== 'none') {
                            let current_field = el.querySelector('div.ginput_container input, div.ginput_container textarea');
                
                            if (el.classList.contains('is-checkbox')) {
                                let atLeastOneIsChecked = el.querySelectorAll('div.ginput_container_checkbox input[type="checkbox"]:checked').length > 0;
                                if (!atLeastOneIsChecked) {
                                    isValidated = false;
                                    el.insertAdjacentHTML('beforeend', '<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                                }
                            } else if (el.classList.contains('is-radio')) {
                                let atLeastOneIsRadio = el.querySelectorAll('div.ginput_container_radio input[type="radio"]:checked').length > 0;
                                if (!atLeastOneIsRadio) {
                                    isValidated = false;
                                    el.insertAdjacentHTML('beforeend', '<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                                }
                            } else if (el.classList.contains('is-list')) {
                                let atLeastOneHasTextEmpty = el.querySelectorAll('table.gfield_list input:text').forEach(function(textInput) {
                                    return !textInput.value;
                                }).length > 0;
                                if (atLeastOneHasTextEmpty) {
                                    isValidated = false;
                                    el.insertAdjacentHTML('beforeend', '<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>');
                                }
                            } else if (el.classList.contains('is-address')) {
                                let atLeastOneHasTextEmpty = false;
                                el.querySelectorAll('div.ginput_container input').forEach(function(field) {
                                    let jq_this = field;
                                    if (!jq_this.value && !jq_this.parentNode.classList.contains('ginput_full', 'address_line_2')) {
                                        atLeastOneHasTextEmpty = true;
                                        jq_this.parentNode.insertAdjacentHTML('beforeend', '<span class="gfield_description validation_message" style="display:block;">' + errorMessage + '</span>');
                                    }
                                });
                                if (atLeastOneHasTextEmpty) {
                                    isValidated = false;
                                }
                            } else if (el.classList.contains('is-select')) {
                                let atLeastOneHasTextEmpty = false;
                                el.querySelectorAll('div.ginput_container select').forEach(function(field) {
                                    let jq_this = field;
                                    if (!jq_this.value) {
                                        atLeastOneHasTextEmpty = true;
                                        jq_this.parentNode.insertAdjacentHTML('beforeend', '<span class="gfield_description validation_message" style="display:block;">' + errorMessage + '</span>');
                                    }
                                });
                                if (atLeastOneHasTextEmpty) {
                                    isValidated = false;
                                }
                            }

                            else if (current_field.value === '' && !el.classList.contains('is-address')) {
                                isValidated = false;
                                el.innerHTML += '<div class="gfield_description validation_message" style="display:block;">' + errorMessage + '</div>';
                            } 
                                
                            else if (el.classList.contains('email-format')) {
                                let pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})+$/;
                                
                                if (!pattern.test(current_field.value)) {
                                    isValidated = false;
                                    el.innerHTML += '<div class="gfield_description validation_message" style="display:block;">' + emailFormatErrorMessage + '</div>';
                                }
                            }


                        }



                    }); // .each

                    if (isValidated) {
                        const submitBtn = the_form.querySelector('input[type="submit"].gform_button.button');
                        submitBtn.click();
                        return true;
                    } 
                    
                    else {
                        thissubbtn.removeAttribute('disabled');
                        thissubbtn.value = oldbtntext;
                        return false;
                    }
                });

            }); // .onclick
        },

        getViewport : () => {
            
            let e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
            
        },

        vpWidth : () => { return pbmain.getViewport().width },
        vpHeight : () => { return pbmain.getViewport().height },


        initLogoCarousel : () => {
                
            $('div.logo-carousel').slick({
                centerPadding: '60px',
                slidesToShow: 6,
                slidesToScroll: 6,
                arrows: false,
                dots: true,
                autoplay: true,
                autoplaySpeed: 5000,
                speed: 1200,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            arrows: false,
                            dots: true,
                            centerPadding: '40px',
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            dots: true,
                            centerPadding: '40px',
                            slidesToShow: 3,
                            slidesToScroll: 3,
                        }
                    },

                    {
                        breakpoint: 600,
                        settings: {
                            arrows: true,
                            dots: false,
                            centerPadding: '40px',
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },

                    {
                        breakpoint: 480,
                        settings: {
                            arrows: true,
                            dots: false,
                            centerPadding: '40px',
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    }
                ]
            });
            

        },

        initPopupFormTriggers : () => {

            $('.subscribe-to-newsletter-popup-firstfield').on('click', function(e) {

                e.preventDefault();
                
                $('.subscribe-to-newsletter-popup-trigger').trigger('click');
                
            });
        },

        initSectorsFilter: () => {

            function ajaxFilter() {
                var sector = $('select[name="sector"]').val();
                var service = $('select[name="service"]').val();
                
                $.ajax({
                    url: ajax_params.ajax_url,
                    type: 'post',
                    data: {
                        action: 'filter_projects',
                        sector: sector,
                        service: service,
                    },
                    beforeSend: function() {
                        $('.projects-wrap').toggleClass('loading');
                    },
                    success: function(response) {
                        
                        console.log(response);

                        $('#projects-grid').html(response);
                    },
                    error: function(xhr, ajaxOptions, thrownError) {
                        
                        console.log('AJAX Error: ' + thrownError);
                    },
                    complete: function() {
                        $('.projects-wrap').toggleClass('loading');
                    }
                });
            }
        
            $('select[name="sector"], select[name="service"]').on('change', function() {
                ajaxFilter();
            });
        }
        
    };
    
    window.purebolddirectorymain = pbmain;

	$( document ).ready(function() { 
		
		window.purebolddirectorymain.init();
		
		
	});
   
	
})(jQuery);